import { queryOptions } from '@tanstack/react-query';

import apiClient from '@/constants/http';
import { Logger } from '@/utils/logging';

import type {
  StandbyPublicStylistsResponse,
  StandbyStylistsQueryKey,
} from './types';

const fetchStandbyStylists = async (
  shopId: string,
  signal?: AbortSignal,
): Promise<StandbyPublicStylistsResponse> => {
  try {
    const { data } = await apiClient.get<StandbyPublicStylistsResponse>(
      `/v1/standby-list/public/${encodeURIComponent(shopId)}/stylists`,
      { signal },
    );

    return data;
  } catch (error) {
    Logger.error('Error fetching standby stylists', { error });

    throw error;
  }
};

// UUID-only endpoint: pass the resolved shop id, never a route slug.
export const standbyStylistsQuery = (shopId: string) =>
  queryOptions<
    StandbyPublicStylistsResponse,
    Error,
    StandbyPublicStylistsResponse,
    StandbyStylistsQueryKey
  >({
    queryKey: ['standby', 'stylists', shopId],
    queryFn: ({ signal }) => fetchStandbyStylists(shopId, signal),
    enabled: !!shopId,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
